export default "__VITE_ASSET__Bf_3pLDj__"